import React from 'react';
import { FormattedMessage } from 'react-intl';
import Heading from '@bibliocommons/heading';
import { CriticsReviewsContainer } from './CriticsReviews';
import { StaffCommentsContainer } from './StaffComments';
import { CommunityCommentsContainer } from './CommunityComments';
import './Opinion.scss';

export default class Opinion extends React.PureComponent {
  render() {
    return (
      <section className="cp-bib-opinion container">
        <div className="row">
          <div className="col-lg-3">
            <Heading tagName="h2" size="moderate" variant>
              <FormattedMessage id="opinion_section" />
            </Heading>
          </div>
          <div className="col-lg-7 sections">
            <CriticsReviewsContainer />
            <StaffCommentsContainer />
            <CommunityCommentsContainer />
          </div>
        </div>
      </section>
    );
  }
}
